import ProductFactory from "../../../models/ProductFactory";

/**
 * Traduce los códigos de barras del contrato de compras ({ barras, unidades }) a la forma
 * que comparten ListOrder y OrderProduct con ventas ({ BARRAS, UNIDADES })
 */
export const adaptarBarras = (barras) =>
    (barras || []).map((b) => ({ BARRAS: b.barras, UNIDADES: b.unidades }));

/**
 * Referencia con la que se registra el punteo de una línea: los artículos repetidos en
 * el pedido se distinguen por su número de línea
 */
export const referenciaRegistro = (linea) =>
    linea.duplicado ? `${linea.articulo}-${linea.linea}` : linea.articulo;

/**
 * Convierte una línea de pedido de compra y su registro de punteo en el Product de la lista
 * @param {Object} linea - Línea de GET /compras/buscar
 * @param {Object} [registro] - Primer registro de GET /compras/obtener, si lo hay
 * @param {boolean} esExcluida - Referencia que no se puntea (portes, etc.): cuenta como completa
 * @param {number} index - Posición en la lista
 */
export const lineaCompraAProducto = (linea, registro, esExcluida, index) => {
    let unidades = linea.unidades;
    let remaining = unidades;
    let state = 0;
    let register = 0;
    let registerDate;
    let manual = false;

    if (esExcluida) {
        unidades = 0;
        remaining = 0;
        state = 1;
    } else if (registro) {
        remaining = unidades - registro.unidades;
        register = registro.unidades;
        registerDate = registro.registrado;
        manual = registro.manual;
        if (remaining === 0) {
            state = 1;
        }
    }

    const info = linea.infoArticulo;

    // infoArticulo es null si el artículo ya no existe en Eurowin: la línea se muestra
    // igualmente, sin nombre, ubicación ni códigos de barras
    return ProductFactory.productOrder(
        linea.numero, linea.articulo, adaptarBarras(info?.barras), info?.nombre, unidades,
        info?.ubicacion, info?.venSerie, remaining, state, register, linea.duplicado,
        linea.linea, registerDate, manual, index
    );
};
